import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInputGroup, LinkedInput, NoContentBox } from 'components/basic'
import { Installation } from 'config'
import { notify, Translate, date } from 'helpers'
import Select from 'react-select'
import http from 'API/http'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import CharacteristicsWidget from './CharacteristicsWidget'

class Subscriptions extends Component {
  constructor (props) {
    super(props)
    this.state = {
      subscriptions: [],
      services: [],
      orders: [],
      loading: true,
      serviceToConnect: {},
      selectedService: {},
      accessId: '',
      updated: null
    }
  }

  componentDidMount () {
    this.setSubscriptions(this.props)
  }

  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.setSubscriptions(props)
  }

  setSubscriptions (props) {
    this.setState({subscriptions: props.subscriptions, accessId: props.accessId, services: props.services, loading: true, updated: props.updated})
    this.getOrders(props.accessId)
  }

  async getOrders (id) {
    //eslint-disable-next-line
    var [err, res] = await http.get('2.4/orders', { accessId: id })
    this.setState({orders: res.data, loading: false})
  }

  async deactivateService () {
    this.setState({deactivating: true})
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      operation: 'DEACTIVATE',
      requestedDateTime: (!this.state.selectedService.operationDate ? null : moment(this.state.selectedService.operationDate).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"))
    })
    if (err) {
      this.setState({deactivating: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({deactivateModal: false, deactivating: false})
    notify.alert('', 'The service will be deactivated ' + (!this.state.selectedService.operationDate ? 'soon.' : moment(this.state.selectedService.operationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.props.callback()
  }

  async modifyService () {
    this.setState({modifying: true})
    var valid = await new Promise((resolve, reject) => { this.editForm.check(resolve) })
    var characteristics = {}
    Object.entries(this.setCharacteristics()).map(([key, value]) => {
      if (value.required && value.value.length === 0) {
        notify.warn('Value is required for ' + key)
        return valid = false
      }
      characteristics[key] = value.value
    })
    if (!valid) return this.setState({modifying: false})
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      spSubscriptionId: this.state.selectedService.spSubscriptionId,
      characteristics: characteristics,
      spReference: this.state.selectedService.spReference,
      operation: 'MODIFY'
    })
    if (err) {
      this.setState({modifying: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({editModal: false, modifying: false, selectedService: {}})
    notify.alert('', 'Modify order created!', 'success')

    this.props.callback()
  }

  isDateValid (current) {
    if (current === null) current = moment()
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }

  async changeService () {
    if (!this.state.serviceToConnect.service) return notify.warn('You need to select a service')
    this.setState({changing: true})
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.serviceToConnect.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.selectedService.operationDate ? moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]') : moment(this.state.selectedService.operationDate).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")),
      operation: 'CHANGE'
    })

    if (err) {
      this.setState({changing: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({changeModal: false, changing: false})
    notify.alert('', 'The service will be changed ' + (!this.state.selectedService.operationDate ? 'soon.' : moment(this.state.selectedService.operationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.props.callback()
  }

  async suspendService () {
    this.setState({suspending: true})
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.selectedService.operationDate ? moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]') : moment(this.state.selectedService.operationDate).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")),
      operation: 'SUSPEND'
    })
    if (err) {
      this.setState({suspending: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({suspendModal: false, suspending: false})
    notify.alert('', 'The service will be suspended ' + (!this.state.selectedService.operationDate ? 'soon.' : moment(this.state.selectedService.operationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.props.callback()
  }

  async resumeService () {
    this.setState({resuming: true})
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      requestedDateTime: (!this.state.selectedService.operationDate ? moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]') : moment(this.state.selectedService.operationDate).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")),
      operation: 'RESUME'
    })
    if (err) {
      this.setState({resuming: false})
      return notify.alert('', res.cause, 'error')
    }
    this.setState({resumeModal: false, resuming: false})
    notify.alert('', 'The service will be resumed ' + (!this.state.selectedService.operationDate ? 'soon.' : moment(this.state.selectedService.operationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.props.callback()
  }

  getOperationalState (state) {
    switch (state) {
      case 'ACTIVATED':
        return <span className='label orders-label label-success'><i className='fa fa-fw fa-check' /><b>{state}</b></span>
      case 'SUSPENDED':
        return <span className='label orders-label label-dark'><i className='fa fa-fw fa-ban' /><b>{state}</b></span>
      default:
        return <span className='label orders-label label-dark'><b>{state}</b></span>
    }
  }
  render () {

    return (
      <div>
        <StaticBox cols={12} icon='handshake-o' title={Translate({'SE': 'Tjänster', 'EN': 'Subscriptions'})}>
          <FlowTable hideHeaders emptyIcon='fa-handshake-o' emptyText='No Subscriptions Available' loading={this.state.loading} data={this.state.subscriptions.map(subscription => [
            <div style={{'display': 'flex'}}>
              {[
                <a hidden={((typeof this.state.orders.find(order => order.subscriptionId === subscription.subscriptionId && order.state === 'RECEIVED') === 'object' || subscription.deactivationDate && subscription.deactivationDate.length !== 0))} key={subscription.service + 1} data-tip='Manage Subscription' onClick={e => this.setState({selectModal: true, selectedService: subscription})} className='table-link'><i className='fa fa-edit' /></a>,
                (Installation.enable.tickets && Installation.enable.ticketsCreate) ? <a key={subscription.service + 2} data-tip='Create Ticket' onClick={e => (window.location = ('/#/ticket/create/' + this.state.accessId + '/' + subscription.subscriptionId))} className='table-link'><i className='fa fa-ticket' /></a> : (!Installation.enable.ticketsCreate) ? <a onClick={e => this.setState({ticketModal: true})} className='table-link'><i className='fa fa-ticket' /></a> : <i className='fa fa-ban text-muted' />,
                <a hidden={Object.keys(subscription.dhcpIdentifier).length === 0} key={subscription.service + 3} data-tip='Show DCHP Identifiers' onClick={() => this.setState({dhcpIdentifierModal: true, selectedService: subscription})} className='table-link'><i className='fa fa-globe' /></a>,
                <a hidden={subscription.characteristics === null || Object.keys(subscription.characteristics).length === 0} key={subscription.service + 4} data-tip='Show Characteristics' onClick={() => this.setState({characteristicsModal: true, selectedService: subscription})} className='table-link'><i className='fa fa-tags' /></a>
              ]}
            </div>,
            this.getOperationalState(subscription.operationalState),
            subscription.service,
            (!subscription.activationDate ? '' : date.format(subscription.activationDate)),
            subscription.deactivationDate ? date.format(subscription.deactivationDate) : '',
            subscription.spReference,
            subscription.spSubscriptionId,
            subscription.option82
          ])}>
            <tr>
              <th className='buttons' >Actions</th>
              <th>State</th>
              <th>Service</th>
              <th>Activation Date</th>
              <th>Deactivation Date</th>
              <th>Your Internal Reference</th>
              <th>Subscription  Reference</th>
              <th>Option 82</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.selectModal} close={e => this.setState({selectModal: false})}>
          <div className='col-md-9 col-md-push-1 selection-buttons-wrapper'>
            <div className='selection-buttons'>
              <a className='selection-button' onClick={() => this.setState({deactivateModal: true, selectModal: false})}><i className='fa fa-fw fa-times' /> Deactivate <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'SUSPENDED' ? 'hidden' : '')} onClick={() => this.setState({suspendModal: true, selectModal: false})}><i className='fa fa-fw fa-ban' /> Suspend <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'SUSPENDED' ? '' : 'hidden')} onClick={() => this.setState({resumeModal: true, selectModal: false})}><i className='fa fa-fw fa-forward' /> Resume <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'SUSPENDED' ? 'hidden' : '')} onClick={() => this.setState({editModal: true, selectModal: false})}><i className='fa fa-fw fa-edit' /> Edit Parameters <i className='fa fa-fw fa-arrow-right' /></a>
              <a className={'selection-button ' + (this.state.selectedService.operationalState === 'SUSPENDED' ? 'hidden' : '')} onClick={() => this.setState({changeModal: true, selectModal: false})}><i className='fa fa-fw fa-cog' /> Change Service <i className='fa fa-fw fa-arrow-right' /></a>
            </div>
          </div>
        </Modal>
        {/* DEACTIVATE */}
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.deactivateModal} close={e => this.setState({deactivateModal: false, selectedService: {}})} buttons={[
            { disabled: this.state.deactivating, icon: (this.state.deactivating ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.deactivating ? 'Deactivating' : 'Deactivate'), event: e => this.deactivateService() }
        ]}>
          <label>Deactivation time</label>
          <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
            this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
        </Modal>

        {/* RESUME */}
        <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.resumeModal} close={e => this.setState({resumeModal: false, selectedService: {}})} buttons={[
            { disabled: this.state.resuming, icon: (this.state.resuming ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.resuming ? 'Resuming' : 'Resume'), event: e => this.resumeService() }
        ]}>
          <label>Operation time</label>
          <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
            this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
        </Modal>

        {/* MODIFY */}
        <Modal title={'Edit references for ' + this.state.selectedService.service} noOverflow isOpen={this.state.editModal} close={e => this.setState({editModal: false, selectedService: {}})} buttons={[
            { disabled: this.state.modifying, icon: (this.state.modifying ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.modifying ? 'Updating' : 'Update') , event: e => this.modifyService() }
        ]}>
          <LinkedInputGroup ref={(form) => { this.editForm = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='selectedService.spReference' />
              </div>
              <div className='form-group col-md-12'>
                <label>Subscription Reference</label>
                <LinkedInput context={this} path='selectedService.spSubscriptionId' />
              </div>
            </div>
          </LinkedInputGroup>
          <div className='row'>
            {this.state.selectedService && this.state.selectedService.characteristics && <CharacteristicsWidget getCharacteristics={characteristics => this.setCharacteristics = characteristics} updated={this.state.updated} characteristics={this.state.selectedService.characteristics} editable />}
          </div>
        </Modal>

        {/* SHOW DHCP IDENTIFIER */}
        {this.state.selectedService && this.state.dhcpIdentifierModal && <Modal title={this.state.selectedService.service + ' DHCP Identifiers'} noOverflow isOpen={this.state.dhcpIdentifierModal} close={e => this.setState({dhcpIdentifierModal: false, selectedService: null})}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>ipv4CircuitId</label>
              <LinkedInput editable={false} context={this} path='selectedService.dhcpIdentifier.ipv4CircuitId' />
            </div>
            <div className='form-group col-md-12'>
              <label>ipv4RemoteId</label>
              <LinkedInput editable={false} context={this} path='selectedService.dhcpIdentifier.ipv4RemoteId' />
            </div>
            <div className='form-group col-md-12'>
              <label>ipv6InterfaceId</label>
              <LinkedInput editable={false} context={this} path='selectedService.dhcpIdentifier.ipv6InterfaceId' />
            </div>
            <div className='form-group col-md-12'>
              <label>ipv6RemoteId</label>
              <LinkedInput editable={false} context={this} path='selectedService.dhcpIdentifier.ipv6RemoteId' />
            </div>
          </div>
        </Modal>}

        {/* SHOW CHARACTERISTICS */}
        {this.state.selectedService && this.state.selectedService.characteristics &&
          <Modal title={this.state.selectedService.service + ' Characteristics'} noOverflow isOpen={this.state.characteristicsModal} close={e => this.setState({characteristicsModal: false, selectedService: {}})}>
            <div className='row'>
              <CharacteristicsWidget updated={this.state.updated} characteristics={this.state.selectedService.characteristics} editable={false} />
            </div>
          </Modal>
        }

        {/* SUSPEND SERVICE */}
        <Modal title={'Suspend ' + this.state.selectedService.service} noOverflow isOpen={this.state.suspendModal} close={e => this.setState({suspendModal: false, selectedService: {}})} buttons={[
            { disabled: this.state.suspending, icon: (this.state.suspending ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.suspending ? 'Suspending' : 'Suspend'), event: e => this.suspendService() }
        ]}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Suspended From</label>
              <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
                this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
              }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'Select a date'}} timeFormat={'HH:mm'} renderInput={props =>
                <div className='input-group'>
                  <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                  <input {...props} className='form-control' />
                </div>
              } />
            </div>
          </div>
        </Modal>

        {/* CHANGE SERVICE */}
        <Modal noOverflow title={'Change ' + this.state.selectedService.service} isOpen={this.state.changeModal} close={e => this.setState({changeModal: false, selectedService: {}})} buttons={[
          { disabled: this.state.changing, icon: (this.state.changing ? 'fa-circle-o-notch fa-spin' : ''), text: (this.state.changing ? 'Changing' : 'Change'), event: e => this.changeService() }
        ]}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Operation Date</label>
              <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.selectedService.operationDate} onChange={date => {
                this.setState({selectedService: {...this.state.selectedService, operationDate: date}})
              }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'Select a date'}} timeFormat={'HH:mm'} renderInput={props =>
                <div className='input-group'>
                  <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                  <input {...props} className='form-control' />
                </div>
              } />
            </div>
          </div>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>New Service</label>
              <Select
                value={this.state.serviceToConnect}
                onChange={service => this.setState({serviceToConnect: {...this.state.serviceToConnect, service: service.service}})}
                options={this.state.services.filter(service => service.status === '1' && service.service !== this.state.selectedService.service && (service.productGroup_id === this.state.selectedService.productGroup_id || !service.productGroup_id))}
                valueKey='service'
                labelKey='service'
                clearable={false}
              />
            </div>
          </div>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
      </div>
    )
  }
}
export default Subscriptions



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/Subscriptions.js